"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41148],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 635412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82389);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(281668);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .getArrowClassName */ .C)(attributes) || ""
  }), menu));
};
const DropdownMenu = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const StyledArrow = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 174925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BottomActionBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBottomActionBar = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(`
  padding-bottom: env(safe-area-inset-bottom);
  min-height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  border-top: 1px solid #ddd;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  z-index: 1030;
  display: flex;
  align-items: center;
  justify-content: space-between;
  `, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const BottomActionBar = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottomActionBar, __spreadValues({}, props), children);
};




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 590498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ RelatedPromotionV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(853675);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(243290);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);






const renderDetailPromotionContent = (benefit, isCoupon, showGiftValueInRelatedPromotions)=>{
    const { gifts , voucher , discount  } = benefit;
    const renderAndText = " " + (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("v\xe0") + " ";
    const renderDiscount = ()=>{
        if (discount && Object.keys(discount).length) {
            const { percent , maxAmount , flat  } = discount;
            return percent !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("{{percent}}% ", {
                        percent: percent
                    }),
                    !!maxAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tối đa"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                                value: maxAmount
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                value: flat || 0
            });
        }
    };
    const renderGifts = ()=>{
        if (gifts && gifts.length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: gifts.map((param, index)=>/*#__PURE__*/ {
                    let { name , quantity , imageUrl , sellPrice  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: " ".concat(quantity, " ").concat(name)
                            }),
                            !!showGiftValueInRelatedPromotions && !!sellPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    " ".concat((0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("trị gi\xe1")),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                                        value: sellPrice
                                    })
                                ]
                            }),
                            !!imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                style: {
                                    objectFit: "contain",
                                    height: "20px",
                                    width: "20px"
                                },
                                src: imageUrl,
                                alt: name
                            }),
                            index !== gifts.length - 1 && ", "
                        ]
                    }, "".concat(index).concat(name));
                })
            });
        }
        return null;
    };
    const renderVoucher = ()=>{
        if (voucher && Object.keys(voucher).length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: voucher.name ? "".concat(voucher.quantity, " ").concat(voucher.name) : "Voucher"
            });
        }
        return null;
    };
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderDiscount() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("giảm") + " ",
            renderDiscount(),
            renderDiscount() && renderGifts() && renderAndText,
            renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            renderGifts(),
            renderDiscount() && renderVoucher() && !renderGifts() && renderAndText,
            renderGifts() && renderVoucher() && ", ",
            renderVoucher() && !renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            " ",
            renderVoucher()
        ]
    });
    if (!isCoupon) {
        let spinner = true;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(content, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(content.props.children, (element)=>{
                if (typeof element === "string" && spinner) {
                    if (!!element) {
                        spinner = false;
                        return element.charAt(0).toUpperCase() + element.slice(1);
                    }
                }
                return element;
            })
        });
    }
    return content;
};
const RelatedPromotionV2 = (param)=>{
    let { validPromotion  } = param;
    const { showGiftValueInRelatedPromotions  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    const { isDefault , benefit , condition , type , description  } = validPromotion;
    const isCoupon = !isDefault && type === "coupon";
    const isGiftCode = !isDefault && type === "gift-code";
    // Custom magento from PPM
    if (type === "qr") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: description || ""
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            (isCoupon || isGiftCode) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Nhập m\xe3"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: (condition === null || condition === void 0 ? void 0 : condition.coupon) || ""
                    }),
                    " "
                ]
            }),
            renderDetailPromotionContent(benefit, isCoupon || isGiftCode, showGiftValueInRelatedPromotions),
            " ",
            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("cho đơn h\xe0ng"),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMin) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("từ"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMin
                    })
                ]
            }),
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMax) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("đến"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMax
                    })
                ]
            }),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.hasProductCondition) && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("c\xf3 sản phẩm n\xe0y"),
            isDefault && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("sites.shop-front.components.RelatedPromotion.0")
        ]
    });
};


/***/ }),

/***/ 124177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ INLINE_BANNER_CLASSNAME; }
/* harmony export */ });
var INLINE_BANNER_CLASSNAME;
(function(INLINE_BANNER_CLASSNAME) {
    INLINE_BANNER_CLASSNAME["INLINE_HOME_TOP"] = "INLINE-HOME-TOP";
    INLINE_BANNER_CLASSNAME["INLINE_HOME_BODY"] = "INLINE-HOME-BODY";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_RELATEDPROMO"] = "INLINE-PDP-RELATEDPROMO";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_SERVICE"] = "INLINE-PDP-SERVICE";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_DESK"] = "INLINE-PDP-PREVIEW-DESK";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_MOBILE"] = "INLINE-PDP-PREVIEW-MOBILE";
    INLINE_BANNER_CLASSNAME["INLINE_SEARCH"] = "INLINE-SEARCH";
    INLINE_BANNER_CLASSNAME["INLINE_CATEGORY"] = "INLINE-CATEGORY";
    INLINE_BANNER_CLASSNAME["INLINE_BRAND"] = "INLINE-BRAND";
    INLINE_BANNER_CLASSNAME["INLINE_SELLER"] = "INLINE-SELLER";
    INLINE_BANNER_CLASSNAME["INLINE_CART"] = "INLINE-CART";
    INLINE_BANNER_CLASSNAME["INLINE_CHECKOUT"] = "INLINE-CHECKOUT";
})(INLINE_BANNER_CLASSNAME || (INLINE_BANNER_CLASSNAME = {}));


/***/ }),

/***/ 347822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollSmoothToIdWithOffset; },
/* harmony export */   "a": function() { return /* binding */ scrollSmoothToId; }
/* harmony export */ });
const scrollSmoothToId = (id)=>{
    const element = document.getElementById(id);
    element === null || element === void 0 ? void 0 : element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
const scrollSmoothToIdWithOffset = function(id) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
    const element = document.getElementById(id);
    if (!element) return;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 152262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ BreadcrumbSchema; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(316035);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(634655);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);







const BreadcrumbSchema = ()=>{
    const { breadcrumbs  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useProductDetailState */ .W)();
    const { baseDomain , addSchemaBreadcrumbList  } = (0,hooks__WEBPACK_IMPORTED_MODULE_5__/* .useTenantConfig */ .Wx)();
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !!addSchemaBreadcrumbList && !!(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        itemListElement: breadcrumbs.map((param, index)=>{
                            let { name , link , isLast  } = param;
                            return {
                                "@type": "ListItem",
                                position: index + 1,
                                item: {
                                    name: !index ? (0,i18n__WEBPACK_IMPORTED_MODULE_6__.t)("Trang chủ") : name,
                                    "@id": link === "#" || !!isLast ? "".concat(baseDomain).concat(asPath) : "".concat(baseDomain).concat(link)
                                }
                            };
                        })
                    })
                }
            })
        })
    });
};


/***/ }),

/***/ 812388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MetaData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(665207);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(316035);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





const MetaData = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    const { product , primitiveProduct , serverRating  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useProductDetailState */ .W)();
    const { baseDomain , canonicalDomain  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    let canonical;
    if (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref = primitiveProduct.productInfo) === null || ref === void 0 ? void 0 : ref.canonical) {
        if (canonicalDomain) {
            canonical = "".concat(canonicalDomain, "/").concat(primitiveProduct.productInfo.canonical);
        } else if (baseDomain) {
            canonical = "".concat(baseDomain, "/").concat(primitiveProduct.productInfo.canonical);
        }
    }
    const data = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref1 = primitiveProduct.productInfo) === null || ref1 === void 0 ? void 0 : ref1.name,
        image: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref2 = primitiveProduct.productInfo) === null || ref2 === void 0 ? void 0 : ref2.imageUrl,
        brand: {
            "@type": "Brand",
            name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref3 = primitiveProduct.productInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.brand) === null || ref4 === void 0 ? void 0 : ref4.name
        },
        offers: {
            "@type": "Offer",
            price: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref5 = primitiveProduct.prices) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.latestPrice) || 0,
            url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref7 = primitiveProduct.productInfo) === null || ref7 === void 0 ? void 0 : ref7.canonical),
            priceCurrency: "VND",
            itemCondition: "https://schema.org/NewCondition",
            availability: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) === null || !!(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        },
        url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref8 = primitiveProduct.productInfo) === null || ref8 === void 0 ? void 0 : ref8.canonical),
        description: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref9 = primitiveProduct.productDetail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.seoInfo) === null || ref10 === void 0 ? void 0 : ref10.metaDescription,
        sku: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref11 = primitiveProduct.productInfo) === null || ref11 === void 0 ? void 0 : ref11.sku,
        category: (ref12 = primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.productInfo.categories) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.name,
        additionalProperty: product === null || product === void 0 ? void 0 : (ref14 = product.attributeGroups) === null || ref14 === void 0 ? void 0 : ref14.filter((att)=>!!att.value && att.parentId !== 0).map((att)=>({
                "@type": "PropertyValue",
                name: att.name,
                value: att.value
            })),
        video: product === null || product === void 0 ? void 0 : (ref15 = product.seoInfo) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.relatedVideos) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.urls) === null || ref17 === void 0 ? void 0 : ref17.map((url)=>({
                "@type": "VideoObject",
                url: url.url,
                thumbnailUrl: url.thumbnailUrl,
                description: url.description,
                uploadDate: url.uploadDate,
                name: url.name
            })),
        aggregateRating: !!(serverRating === null || serverRating === void 0 ? void 0 : serverRating.totalReviews) ? {
            "@type": "AggregateRating",
            bestRating: "5",
            worstRating: "1",
            ratingValue: serverRating === null || serverRating === void 0 ? void 0 : serverRating.averageRating,
            reviewCount: serverRating === null || serverRating === void 0 ? void 0 : serverRating.totalReviews
        } : undefined,
        review: !!(serverRating === null || serverRating === void 0 ? void 0 : serverRating.reviews.length) ? serverRating.reviews.slice(0, 5).map((review)=>({
                "@type": "Review",
                datePublished: typeof review.createdAt === "number" ? new Date(review.createdAt * 1000).toISOString() : "",
                reviewBody: review.review.comment,
                author: {
                    "@type": "Person",
                    name: review.userName || "Th\xe0nh vi\xean ẩn danh"
                },
                reviewRating: {
                    "@type": "Rating",
                    bestRating: "5",
                    ratingValue: review.review.rating
                }
            })) : undefined
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(data)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_4__/* .HeadSection */ .I, {
                canonical: canonical,
                title: (product === null || product === void 0 ? void 0 : (ref18 = product.seoInfo) === null || ref18 === void 0 ? void 0 : ref18.metaTitle) || (product === null || product === void 0 ? void 0 : product.name),
                description: (product === null || product === void 0 ? void 0 : (ref19 = product.seoInfo) === null || ref19 === void 0 ? void 0 : ref19.metaDescription) || false,
                keywords: product === null || product === void 0 ? void 0 : (ref20 = product.seoInfo) === null || ref20 === void 0 ? void 0 : ref20.metaKeyword,
                image: product === null || product === void 0 ? void 0 : (ref21 = product.images) === null || ref21 === void 0 ? void 0 : (ref22 = ref21[0]) === null || ref22 === void 0 ? void 0 : ref22.src
            })
        ]
    });
};


/***/ }),

/***/ 111474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(825078);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(743126);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(408797);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);




const StarRating = (props)=>{
    const { value , max =5 , starSize =20 , ratedColor =_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.support */ .E.support , unratedColor =_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.divider */ .E.divider , gap =2 ,  } = props;
    const stars = Array.from({
        length: max
    }, (_, i)=>i + 1);
    const fullStars = Math.floor(value);
    const starPercentage = value - fullStars;
    const hasHalfStar = starPercentage >= 0.1 && starPercentage < 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
        align: "middle",
        width: "fit-content",
        style: {
            gap: gap
        },
        children: stars.map((star)=>{
            if (star <= fullStars) {
                // full star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                    size: starSize,
                    color: ratedColor
                }, star);
            } else if (star === fullStars + 1 && hasHalfStar) {
                // half star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        position: "relative",
                        width: starSize,
                        height: starSize
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                            size: starSize,
                            color: unratedColor,
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "".concat(starPercentage * 100, "%"),
                                height: "100%",
                                overflow: "hidden"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                                size: starSize,
                                color: ratedColor,
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0
                                }
                            })
                        })
                    ]
                }, star);
            } else {
                // empty star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                    size: starSize,
                    color: unratedColor
                }, star);
            }
        })
    });
};


/***/ })

}]);